import { render, staticRenderFns } from "./DepartmentPriority.vue?vue&type=template&id=16cb4cb2&scoped=true"
import script from "./DepartmentPriority.vue?vue&type=script&lang=js"
export * from "./DepartmentPriority.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPriority.vue?vue&type=style&index=0&id=16cb4cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb4cb2",
  null
  
)

export default component.exports